import React from "react";
import VideoPlayer from "../../../../common/ui/VideoPlayer";

type Props = {
  /**
   * Per-walkthrough self-hosted video URL (Azure blob MP4). Rendered by the
   * shared `VideoPlayer` as a native `<video>` with a first-frame preview +
   * branded play button.
   */
  videoUrl: string;
  /**
   * Poster still shown until the user hits play. Without it the player has to
   * decode a frame off the master before it can show anything but black.
   */
  poster?: string;
};

/**
 * Walkthrough detail player. Uses the shared `VideoPlayer` (our own
 * branded-button player, not react-player/YouTube-coupled).
 */
const WalkthroughVideoPlayer = ({ videoUrl, poster }: Props) => {
  return <VideoPlayer src={videoUrl} poster={poster} />;
};

export default WalkthroughVideoPlayer;
